<template>
  <div class="radio-card relative flex pointer pa3 cover bg-center">
    <div class="flex-column w-100">
      <div class="radio-info" @click="listenToRadio">
        <div class="body relative hide-child">
          <img class="radio-picture db" :src="listPicture" :alt="`${radio.name} Picture`">
        </div>
        <div class="flex items-center justify-center bg-primary mw-90">
          <p class="z-1 white-90 word-wrap flex f5 radio-name ma3 rname">{{ radio.name }}</p>
        </div>
        <div class="flex items-center justify-center bg-primary mw-90">
          <p class="z-1 white-90 word-wrap flex f5 radio-name ma3 rcategory">{{ radio.category }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import {mapActions} from 'vuex'

export default {
  name: 'radio-card',
  props: ['radio'],
  components: {FontAwesomeIcon},
  computed: {
    listPicture () {
      if (this.radio.picture) {
        return this.radio.picture
      } else {
        return '/static/assets/radio_online.jpg'
      }
    }
  },
  methods: {
    ...mapActions('player', [
      'setPlaying'
    ]),
    listenToRadio () {
      this.setPlaying(false)
      this.$modal.show('local-radio-modal', {
        radioName: this.radio.name,
        radioUrl: this.radio.link,
        radioPicture: this.listPicture,
        radioCategory: this.radio.category,
        radioDial: this.radio.dial
      })
      /*
      let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=600,height=300,left=400,top=250`
      window.open(this.radio.link, 'radio', params)
      */
    }
  }
}
</script>

<style scoped lang="scss">
  @import '~@/variables.scss';

  a.radio-info:link, a.radio-info:visited {
    color: #FFFFFF;
    text-decoration: none;
  }

  .radio-card {
    width: 15rem;
    flex-shrink: 0;
    flex-grow: 0;
    transition: all .6s;
  }

  .radio-name {
    overflow: hidden;
    text-overflow: ellipsis;
    min-height: 18px;
  }

  .radio-picture {
    line-height: 0;
    height: 13rem;
    object-fit: cover;
    width: 100%;
    border-radius: 100px;
  }

  .word-wrap {
    word-break: break-all;
  }

  .rname {
    margin-bottom: 0px !important;
  }
  .rcategory {
    margin-top: 5px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/localRadios/RadioCard.vue